<template>
    <header>
        <h1><span class="header-top"><!--<span v-if="this.indexC % 2 === 0">{{ `Answer to` }} </span> Interview Question</span>-->
        {{ this.indexC % 2 === 0 ? `Answer to` : `` }} Interview Question</span>

        <!--funkar med första-->
     <!--   <span class="header-number bounce"><span class="dropIn">{{ headernumberC }}</span></span> -->

        <!--funkar med första och css animationer-->
        <!--<span v-if="this.indexC === 1" class="header-number bounce"><span class="dropIn">{{ headernumberC }}</span></span>-->
        <!--<span v-show="this.indexC === 1" class="header-number bounce"><span class="dropIn">{{ headernumberC }}</span></span>-->

        <!--<span v-else-if="this.indexC === 2" class="header-number"><transition name="fnyOut" mode="out-in" key="qwe"><span class="fny1">{{ headernumberC }}</span></transition></span>-->

        <!-- <span v-else-if="this.indexC === 2" class="header-number"><transition name="custom-classes-transition" leave-active-class="animated asd" key="fgh"><span class="fny1">{{ headernumberC }}</span></transition></span> -->

        <!--<span v-else-if="this.indexC === 3" class="header-number"><transition name="fnyIn" mode="out-in" key="ert"><p class="fny">{{ headernumberC }}</p></transition></span>-->

        <!-- <span v-else-if="this.indexC === 3" class="header-number"><transition name="custom-classes-transition" enter-active-class="animated slideInRight2" key="ghj"><p class="fny">{{ headernumberC }}</p></transition></span> -->


        <!-- <span v-else class="header-number"><span>{{ headernumberC }}</span></span> -->

        <!--JS hooks för att lägga till klasser som körs vid olika tillfällen. Lägga allt i en metod?-->
        <!-- <span v-show="this.indexC === 2" class="header-number"><transition name="custom-classes-transition" leave-active-class="animated slideInRight2" key="fgh"><span class="fny1">{{ headernumberC }}</span></transition></span>

        <span v-show="this.indexC === 10" class="header-number"><span>{{ headernumberC }}</span></span> -->

        <span v-if="this.indexC === 1" class="header-number bounce"><span class="dropIn">{{ headernumberC }}</span></span>
        <span v-else class="header-number"><span>{{ headernumberC }}</span></span>





        </h1>
    </header>
</template>

<script>
export default {
  /* data: function () {
    return {
      headerindex: 0
    };
  }, */
  props: {
    indexC: {
      type: Number
    },
    headernumberC: {
      type: Number
    }
  }
};
</script>
